const Trie = [
    {
      Topic: "Trie",
      Problem: "Construct a trie from scratch",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/trie-insert-and-search/",
      URL2: "https://www.codingninjas.com/codestudio/problems/implement-trie_631356?topList=love-babbar-dsa-sheet-problems",
      Id: 1
    },
    {
      Topic: "Trie",
      Problem: "Find shortest unique prefix for every word in a given list",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/find-all-shortest-unique-prefixes-to-represent-each-word-in-a-given-list/",
      URL2: "https://www.codingninjas.com/codestudio/problems/shortest-unique-prefix_1094887?topList=love-babbar-dsa-sheet-problems",
      Id: 2
    },
    {
      Topic: "Trie",
      Problem: "Word Break Problem | (Trie solution)",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/word-break-problem-trie-solution/",
      URL2: "https://www.codingninjas.com/codestudio/problems/word-break_1094901?topList=love-babbar-dsa-sheet-problems",
      Id: 3
    },
    {
      Topic: "Trie",
      Problem: "Given a sequence of words, print all anagrams together",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/k-anagrams-1/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/group-anagrams_800285?topList=love-babbar-dsa-sheet-problems",
      Id: 4
    },
    {
      Topic: "Trie",
      Problem: "Implement a Phone Directory",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/phone-directory/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/implement-a-phone-directory_1062666?topList=love-babbar-dsa-sheet-problems",
      Id: 5
    },
    {
      Topic: "Trie",
      Problem: "Print unique rows in a given boolean matrix",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/unique-rows-in-boolean-matrix/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/unique-matrix_1214696?topList=love-babbar-dsa-sheet-problems",
      Id: 6
    }
  ];

export default Trie;